import { Link } from "../router/Router";
import { Seo } from "../components/Seo";

export function NotFoundPage() {
  return (
    <div className="hc-empty hc-notfound">
      <Seo title="Not found" noindex />
      <h1>Page not found</h1>
      <p>We couldn’t find that guide. It may have moved or been renamed.</p>
      <Link to="/" className="hc-btn">
        Back to the Help Center
      </Link>
    </div>
  );
}
